import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export default function Success() {
  const navigate = useNavigate();
  function handleSuccess() {
    navigate(ROUTE_PATHS.ADMIN_CUSTOMERS);
  }

  return (
    <div className="container mx-auto min-h-screen py-10">
      <Card className="mx-auto w-full max-w-md">
        <CardHeader>
          <div className="mb-4 flex items-center justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>

          <CardTitle className="text-center">
            Customer Edited Successfully!
          </CardTitle>
        </CardHeader>

        <CardContent className="flex flex-col items-center">
          <p className="mb-6 text-center">
            The updated customer has been added to your system.
          </p>

          <Button onClick={handleSuccess}>Edit Another Customer</Button>
        </CardContent>
      </Card>
    </div>
  );
}
